<template>
    <nav v-if="!client">
        <div class="row">
            <div class="col-sm-12 col-md-5">
                <div class="dataTables_info">
                    <span class="page-stats">
                        {{pagination.from}} - {{pagination.to}} De {{pagination.total}}
                    </span>
                </div>
            </div>

            <div class="col-sm-12 col-md-7">
                <div class="dataTables_paginate paging_simple_numbers ">
                    <ul class="pagination">
                        <li v-if="pagination.prevPageUrl"  class="paginate_button page-item previous">
                            <a @click="$emit('prev',pagination.prevPageUrl);" class="page-link" >Anterior</a>
                        </li>
                        <li v-else class="paginate_button page-item previous" :class="{disabled:'disabled'}">
                            <a class="page-link" >Anterior</a>
                        </li>

                        <li v-if="pagination.nextPageUrl" class="paginate_button page-item next">
                            <a  class="page-link" @click="$emit('next',pagination.nextPageUrl);">Siguiente</a>
                        </li>
                        <li v-else class= "paginate_button page-item next" :class="{disabled:'disabled'}">
                            <a class="page-link" >Siguiente</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
    
    <nav v-else>
        <div class="row">
            <div class="col-sm-12 col-md-5">
                <div class="dataTables_info">
                    <span class="page-stats">
                        {{pagination.from}} - {{pagination.to}} De {{filtered.length}}
                        <span v-if="filtered.length < pagination.total">`(filtered from {{pagination.total}} total entries)`</span>
                    </span>
                </div>
            </div>

            <div class="col-sm-12 col-md-7">
                <div class="dataTables_paginate ">
                    <ul class="pagination">
                        <li v-if="pagination.prevPage"  class="paginate_button page-item previous">
                            <a @click="$emit('prev');" class="page-link" >Anterior</a>
                        </li>
                        <li v-else class="paginate_button page-item previous" :class="{disabled:'disabled'}">
                            <a class="page-link" >Anterior</a>
                        </li>

                        <li v-if="pagination.nextPage" class="paginate_button page-item next">
                            <a  class="page-link" @click="$emit('next');">Siguiente</a>
                        </li>
                        <li v-else class= "paginate_button page-item next" :class="{disabled:'disabled'}">
                            <a class="page-link" >Siguiente</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        props: ['client', 'filtered'],
        data(){
            return {
                pagination:{
                    lastPage: '',
                    currentPage: '',
                    total: '',
                    lastPageUrl: '',
                    nextPageUrl: '',
                    prevPageUrl: [],
                    from: '',
                    to: ''
                }
            }
        },
        methods:{
            setData(data){
                this.$nextTick(()=>{
                    this.pagination.lastPage    = data.last_page;
                    this.pagination.currentPage = data.current_page;
                    this.pagination.total       = data.total;
                    this.pagination.lastPageUrl = data.last_page_url;
                    this.pagination.nextPageUrl = data.next_page_url;
                    this.pagination.prevPageUrl = data.prev_page_url;
                    this.pagination.from        = data.from;
                    this.pagination.to          = data.to;
                });
            }
        },
    }
</script>